import React, { useEffect, useState } from "react";
import "./HomePage.css";
import Me from "../../assets/Profile-Circle.png";
import HeaderSocials from "./HeaderSocials";
import ScrollDown from "./ScrollDown";
import ShapeBackground from "./ShapeBackground";

const roles = [
  "Backend-End Developer",
  "Tech Enthusiast",
  "Problem Solver",
  "Computer Science Student"
];

const TYPING_SPEED = 100;    // milliseconds per character
const DELETING_SPEED = 100;   // milliseconds per character
const DELAY_BETWEEN_ROLES = 1500; // after typing, before deleting

const HomePage = () => {
  const [index, setIndex] = useState(0);   // index of current role
  const [subIndex, setSubIndex] = useState(0); // current character index
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (index >= roles.length) return;

    const typingTimeout = setTimeout(() => {
      if (isDeleting) {
        if (subIndex === 0) {
          setIsDeleting(false);
          setIndex((prev) => (prev + 1) % roles.length);
        } else {
          setSubIndex((prev) => prev - 1);
        }
      } else {
        if (subIndex === roles[index].length) {
          setIsDeleting(true);
        } else {
          setSubIndex((prev) => prev + 1);
        }
      }
    }, isDeleting ? DELETING_SPEED : TYPING_SPEED);

    return () => clearTimeout(typingTimeout);
  }, [subIndex, isDeleting, index]);

  return (
    <section className="home container dark:bg-gray-800" id="home">
      <div className="intro">
        <img src={Me} alt="Profile" className="home__img" />
        <h1 className="home__name name-animation dark:text-white" style={{ lineHeight: 1.5 }}>
          CHHORN Seyha <br />
          <span className="text-red-500">천세이하</span>
        </h1>

        <div className="typewriter-container">
          <p className="home__education typewriter-text dark:text-white">
            {roles[index].substring(0, subIndex)}
            <span className="cursor text-red-500">|</span>
          </p>
        </div>

        <HeaderSocials />
        <a href="#about" className="btn dark:text-white">
          Hire Me
        </a>
      </div>
      <ShapeBackground />
      <ScrollDown />
    </section>
  );
};

export default HomePage;
